import axios from 'axios';
import Cookies from 'js-cookie';
import { BASE_URL, TIMEOUT } from './constants';

// Set baseURL globally (optional)
axios.defaults.baseURL = BASE_URL;

// Add JWT token to all outgoing requests
axios.interceptors.request.use((config) => {
  const token = Cookies.get('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const CancelToken = axios.CancelToken;
let cancel: any;

const getCategories = async (params: {
  limit: number;
}) => {
  try {
    const res = await axios.get(`/categories`, {
        timeout: TIMEOUT,
        params
    });
    return res.data;
  } catch (e) {
    throw(e);
  }
}

const getProducts = async (params: {
  limit: number;
}) => {
  try {
      if (cancel) {
          cancel();
      }
      const res = await axios.get(`/products`, {
          cancelToken: new CancelToken(function executor(c) {
              cancel = c;
          }),
          timeout: TIMEOUT,
          params
      });
      return res.data;
  } catch (e) {
      throw(e);
  }
}

const getProductBySlug = async (slug: string) => {
  try {
      if (cancel) {
          cancel();
      }
      const res = await axios.get(`/products/slug/${slug}`, {
          cancelToken: new CancelToken(function executor(c) {
              cancel = c;
          }),
          timeout: TIMEOUT
      });
      return res.data;
  } catch (e) {
      throw(e);
  }
}

const getOrder = async (PONumber: string) => {
  try {
    if (cancel) {
      cancel();
    }
    const res = await axios.get(`/orders/track/${PONumber}`, {
      cancelToken: new CancelToken(function executor(c) {
          cancel = c;
      }),
      timeout: TIMEOUT,
    });
    return res.data;
  } catch (e) {
    throw(e);
  }
}

const submitGuestOrder = async (order: any) => {
    try {
        const res = await axios.post(`/orders`, order, {
            timeout: TIMEOUT
        });
        return res.data;
    } catch (e) {
        throw(e);
    } 
}

const register = async (params: {
  email: string;
  password: string;
}) => {
  try {
      const res = await axios.post(`/users/register-v2`, params, {
          timeout: TIMEOUT
      });
      return res.data;
  } catch (e) {
      throw(e);
  } 
}

const login = async (params: {
  email: string;
  password: string;
}) => {
  try {
      const res = await axios.post(`/users/login-v2`, params, {
          timeout: TIMEOUT
      });

      Cookies.set('token', res.data.token, {
        expires: 1,
      });

      return res.data;
  } catch (e) {
      throw(e);
  } 
}

const me = async () => {
  try {
      const res = await axios.get(`/users/me`, {
          timeout: TIMEOUT
      });
      return res.data;
  } catch (e) {
      throw(e);
  } 
}


const submitOrder = async (id: string, params: any) => {
  try {
      const res = await axios.post(`/users/${id}/orders`, params, {
          timeout: TIMEOUT
      });
      return res.data;
  } catch (e) {
      throw(e);
  } 
}

export default {
  getCategories,
  getProducts,
  getOrder,
  getProductBySlug,
  submitGuestOrder,
  register,
  login,
  me,
  submitOrder
}